import type { Enemy } from "../entities/Enemy.ts";

/**
 * Single source of truth for the stealth invariant (D-088 / LD-22.1-1).
 *
 * An unrevealed stealth enemy MUST be invisible and untargetable to every
 * non-Signal interaction: targeting, pierce, chain bounce, splash, synergy
 * AoE, and firewall slow. Each damage/interaction loop must gate on this
 * predicate instead of re-inlining the check — scattered copies are how
 * the secondary breaches (F-01/02/04/05/08) crept in.
 *
 * Reveal is dynamic: leaving a Signal tower's range re-hides the enemy
 * (updateStealthReveal in BeamCombat.ts).
 */
export function isStealthHidden(enemy: Enemy): boolean {
  return enemy.stealth && !enemy.revealed;
}
